module.exports = __webpack_public_path__ + "static/media/slideshow (8).7495a950.png";